import { AxiosResponse } from "axios";
import { AddressRequest, AddressByCompanyBuyerRequest } from "@/main/models/request";
import { AddressByBodyshopResponse, AddressResponse } from "@/main/models/response";
import { Result } from "@/main/models/common/resultResponse";

export abstract class IAddressApi {
	abstract getAddressBodyshop(request: AddressRequest): Promise<AxiosResponse<Result<AddressResponse[]>>>;

	abstract getAddressByBodyshop(request: AddressRequest): Promise<AxiosResponse<Result<AddressByBodyshopResponse[]>>>;

	abstract getBillingAddressSummary(
		request: AddressByCompanyBuyerRequest,
	): Promise<AxiosResponse<Result<AddressByBodyshopResponse[]>>>;
}
